import type { UserTaxOptOutReasonApi } from 'api-typings/users/users';
import type { UserTaxOptOutReason } from './user-tax-opt-out-reasons.model';

export function transformUserTaxOptOutReason(
  reason: UserTaxOptOutReasonApi,
): UserTaxOptOutReason {
  const { id, reason_id, details } = reason;
  return { id, reasonId: reason_id, details };
}
